<template>
  <div>
    <!-- top sales store -->
  </div>
</template>

<script>

export default {
  name: 'MonthlyChargesStore',
  props:{
    // selectedTimePeriod:{default:'day'},
  },
  computed:{
    dataKey(){return 'charges'},
    apiRoutes(){return ['/Daily/RCGB/Charges']},
    apiRoute(){return this.apiRoutes[0]},
    dataArray(){return this[this.dataKey]},
    
    dataKeys(){return this.dataArray.length > 0 ? this.$util.keys(this.dataArray) : []},
    deptKeys(){return this.dataArray.length > 0 ? this.$util.uniqueValuesForKey(this.dataArray, "Dept_ID") : []},

  },
  data(){
    return {
      charges: [],
      error: false,
      isLoading: false,
      // month: "2024-03-01",
      month: moment(new Date()).subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      reloadInterval: undefined,
      reloadTimeout: 1000 * 15,
      dow: false,
      meta:{
      }
    }
  },
  mounted(){
    console.log('DEBUG', 'can I load the store??', this.chargeAccountCompanyNames);
    this.getData();
    // this.reloadInterval = setInterval(this.getData, this.reloadTimeout)
  },
  unmounted() {
    // clearInterval(this.reloadInterval)
  },
  watch: {
  },
  methods:{
    getData(cb){
      console.log(`Getting Data for store name - ${this.$options.name}`);
      // Check if dataKey is an array set in data()
      if (this[this.dataKey] === undefined || !Array.isArray(this[this.dataKey])){
        return;
      }
      // this.transactions = undefined;
      this.$set(this, 'isLoading', true)
      // this.isLoading = true;
      

      const options = {month:this.month};
      this.$axios.post(this.apiRoute, options).then((r)=>{
        this[this.dataKey] = [];
        this.error = false
        this.isLoading = false;
        r.data = r.data.map(row=>{
          row.Grand_Total = Math.abs(row.Grand_Total);
          try{
            row.data_array = JSON.parse(row.data_array);
            // row.account = row.data_array[0];
            row.account = this.$chargeAccountCompanyNames[row.data_array[0]];
            row.plate_number = row.data_array[1];
          }catch(e){
            console.log("Parse error of data_array", e);
          }
          return row;
        })
        r.data = this.$util.sortAscForKeyPath(r.data, 'account');
        //TODO HERE
        this[this.dataKey] = r.data
        typeof cb === "function" ? cb() : 1+1;
        
      }).catch(err =>{
        console.log('Error fetching', this.apiRoute, err)
        this.error = true
      })
    },

    // Helpters
    
  },
}
</script>